var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"square-card",class:{ opacityHalf: _vm.opacityHalf }},[_c('div',{staticClass:"card-title"},[_c('i',{class:_vm.leadingIcon}),_c('p',[_vm._v(_vm._s(_vm.$t(_vm.title)))])]),_c('p',{staticClass:"num"},[_vm._v(" "+_vm._s(_vm.number)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }